import { render, staticRenderFns } from "./uploadmodel.vue?vue&type=template&id=7a052c1f&"
import script from "./uploadmodel.vue?vue&type=script&lang=js&"
export * from "./uploadmodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports